import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { PdfFileProps } from "../../types/common";

export interface SettingsState {
  isImgModalOpen: string | null;
  pdfFile: PdfFileProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  isImgModalOpen: null,
  pdfFile: null,
  loading: false,
  error: null,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    updateIsImgModalOpen: (state, action: PayloadAction<string | null>) => {
      state.isImgModalOpen = action.payload;
    },
    updatePdfFile: (state, action: PayloadAction<PdfFileProps | null>) => {
      state.pdfFile = action.payload;
    },
  },
});

export const { updateIsImgModalOpen, updatePdfFile } = settingsSlice.actions;

export const getIsImgModalOpen = (state: RootState) =>
  state.settings.isImgModalOpen;

export const getPdfFile = (state: RootState) => state.settings.pdfFile;

export default settingsSlice.reducer;
